import { reject, reverse, sortBy, toNumber } from 'lodash-es'
import { storeyToLabel } from '@editor/pages/Plans/components/AddPlanDialog/components/utils'
import { roofStoreyKey } from '@editorStores'

/** Roof first, then numeric storeys descending: Dach, 2. OG, 1. OG, EG. */
export const storeysTopToBottom = (storeys: Iterable<string>) => {
  const list = [...storeys]
  const nonRoof = reverse(
    sortBy(
      reject(list, storey => storey === roofStoreyKey),
      storey => toNumber(storey),
    ),
  )
  return list.includes(roofStoreyKey) ? [roofStoreyKey, ...nonRoof] : nonRoof
}

export const positionPlanDxfFilename = (storeys: string[]) => {
  const nonRoof = storeys
    .filter(storey => storey !== roofStoreyKey)
    .sort((a, b) => Number(a) - Number(b))
  const labels = nonRoof.map(storeyToLabel)
  if (storeys.includes(roofStoreyKey)) {
    labels.push(storeyToLabel(roofStoreyKey))
  }
  return `Positionsplan-${labels.join('+')}.dxf`
}
